import { GetTimesheetSettingsListDocument } from '@oc/pages/settings/TimesheetSettings/home/data/requests/__generated__/getTimesheetSettingsList.graphql';
import { filterNotEmpty } from 'utils/data/listHelpers';
import { logger } from 'utils/logger';
import { TaeSettingsTypes as Types } from '@oc/pages/settings/TimesheetSettings/home/data/types';
import { SettingsGroupSource } from 'common/settingsService/impl/models/SettingsGroupSource';
import { SettingsGroup } from 'common/settingsService/impl/models/SettingsGroup';
import { SettingsGroupItems } from 'common/settingsService/impl/models/SettingsGroupItems';
import { TimesheetSettingsKeyModel } from 'src/graphql/types';

export const taeSettingsSource = new SettingsGroupSource(
  new SettingsGroup(
    'timesheets',
    new SettingsGroupItems<Types.ItemsModel>({
      [TimesheetSettingsKeyModel.Expenses]: { enabled: false },
      [TimesheetSettingsKeyModel.Invoices]: { enabled: false },
      [TimesheetSettingsKeyModel.ExpensesInWorkerProfile]: { enabled: true },
      [TimesheetSettingsKeyModel.ExpensesExport]: { enabled: false },
      [TimesheetSettingsKeyModel.NewExpensesImport]: { enabled: false },
      [TimesheetSettingsKeyModel.Rules]: { enabled: false },
      [TimesheetSettingsKeyModel.ShowTimesheetAmounts]: { enabled: false },
      [TimesheetSettingsKeyModel.MealBreakAttestationRequired]: { enabled: false },
      [TimesheetSettingsKeyModel.AmountCalculationEndDateShift]: { enabled: false },
      [TimesheetSettingsKeyModel.TimeAttestationRequired]: { enabled: false },
      [TimesheetSettingsKeyModel.OnlyShowRouterTimeCodesOnTimesheets]: { enabled: false },
      [TimesheetSettingsKeyModel.TimesheetExportEmptyAllocation]: { enabled: false },
      [TimesheetSettingsKeyModel.BlankDefaultRateFrequency]: { enabled: false },
      [TimesheetSettingsKeyModel.HideDeprecatedRates]: { enabled: false },
      [TimesheetSettingsKeyModel.GlobalStartDate]: { enabled: false },
      [TimesheetSettingsKeyModel.ShowBusinessSiteOnTimesheets]: { enabled: false }
    })
  ),
  {
    query: GetTimesheetSettingsListDocument,
    variables: { page: { limit: 1000, offset: 0 } },
    featureFlags: [
      // tenant flag required to run tae
      {
        source: 'TenantConfig',
        name: 'time-and-expenses-hub'
      }
    ],
    mapper: (response) => {
      const responseData = filterNotEmpty(response.data.timesheetSettingsList?.timesheetSettings);
      if (!responseData.length) {
        logger.warn('No timesheet settings found');
      }
      return SettingsGroupItems.fromArray(responseData?.length ? responseData : []).model;
    }
  }
);
